import "./LaboratoryAnalysis.module.css";
import Header from "@/reusable_sections/Header";
import HeroAnalysis from "./sections/HeroAnalysis";
import AnalysisChallenges from "./sections/AnalysisChallenges";
import RelatedSolutions from "./sections/RelatedSolutions";
import Categories from "./sections/Categories";
import Resources from "./sections/Resources";
import SupportServices from "./sections/SupportServices";
import OptimizeAnalysis from "./sections/OptimizeAnalysis";
import Footer from "@/reusable_sections/Footer";
export default function LaboratoryAnalysisPage() {
  return <div>
      <Header />
      <HeroAnalysis />
      <AnalysisChallenges />
      <RelatedSolutions />
      <Categories />
      <Resources />
      <SupportServices />
      <OptimizeAnalysis />
      <Footer />
    </div>;
}